export default {
  getActiveSessionsData: () => null,
  fetchUserProInfo: () => null,
};
